















































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import ImportacaoPagamentosStore from '@/components/RemuneracaoMedica/financeiro/Store/ImportacaoPagamentosStore'
import StatusChip from '@/components/RemuneracaoMedica/financeiro/components/StatusChip.vue'
import EventBus from '@/plugins/EventBus'
import { RequestMessage } from '@/types/_'
import { maskMoney, maskDate } from '@/utils/common'
import { STATUS_LIQUIDACAO_OPTIONS,
  statusLiquidacaoCor,
  statusLiquidacaoLabel,
  origemPagamentoLabel } from '@/utils/importacaoPagamentos'

@Component({
  components: {
    StatusChip,
  },
})
export default class ViewFinanceiroLiquidacoesRecebiveis extends Vue {
  loadingDataTable: boolean = false

  statusLiquidacaoCor = statusLiquidacaoCor
  statusLiquidacaoLabel = statusLiquidacaoLabel
  origemPagamentoLabel = origemPagamentoLabel

  get store() {
    return getModule(ImportacaoPagamentosStore, this.$store)
  }

  get getRequestMessage() {
    return new RequestMessage()
  }

  get statusOptions() {
    return STATUS_LIQUIDACAO_OPTIONS
  }

  get items() {
    return this.store.liquidacoesList
  }

  get headers() {
    return [
      { text: 'Fonte pagadora', value: 'fontePagadoraNome', align: 'left', sortable: false },
      { text: 'Empresa médica', value: 'empresaMedicaNome', align: 'left', sortable: false },
      { text: 'Valor', value: 'valorPagamento', align: 'right', sortable: false },
      { text: 'Data solicitação', value: 'dataSolicitacao', align: 'center', sortable: false },
      { text: 'Data pagamento', value: 'dataPagamento', align: 'center', sortable: false },
      { text: 'Status', value: 'status', align: 'center', sortable: false },
      { text: 'Origem', value: 'origemPagamento', align: 'center', sortable: false },
      { text: 'Identificador', value: 'identificadorOrigem', align: 'center', sortable: false },
    ]
  }

  get filtroStatus() {
    return this.store.liqFiltroStatus
  }

  set filtroStatus(value: any) {
    this.store.setLiqFiltroStatus(value)
  }

  get identificadorOrigem() {
    return this.store.liqIdentificadorOrigem
  }

  set identificadorOrigem(value: any) {
    this.store.setLiqIdentificadorOrigem(value)
  }

  get getPagina() {
    return this.store.liqPagina
  }

  set getPagina(value: number) {
    this.store.setLiqPagina(value)
  }

  get itemsLength() {
    return Math.ceil(this.store.liqTotalRegistros / this.store.liqQtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  formatMoney(value: any) {
    return maskMoney(value)
  }

  formatDate(date: any) {
    return date ? maskDate(date) : '-'
  }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    await this.store.getLiquidacoes()
    this.loadingDataTable = false
  }

  async filtrar() {
    this.store.setLiqPagina(1)
    await this.getResults(1)
  }

  async limparIdentificador() {
    this.store.setLiqIdentificadorOrigem(null)
    await this.filtrar()
  }

  async mounted() {
    EventBus.$emit('setLoadingRequest', {
      status: this.getRequestMessage.status,
      text: this.getRequestMessage.init.text,
    })
    await this.store.getLiquidacoes()
    EventBus.$emit('clearLoadingRequest')
  }
}
